export default "__VITE_ASSET__YyQ$bEtF__"